import Vue from "vue";
import Router from "vue-router";
import CardNav from "@/components/CardNav";
import LastDeposited from "@/components/LastDeposited";
import Welcome from "@/components/Welcome";
import AccessCode from "@/components/AccessCode";
import SendingPhoto from "@/components/SendingPhoto";
import ProcessCompleted from "@/components/ProcessCompleted";
import PhotoSent from "@/components/PhotoSent";
import ErrorPhoto from "@/components/ErrorPhoto";
import Deposition from "@/components/Deposition";
import ProperPreparation from "@/components/ProperPreparation";
import EndTreatmentNewPhoto from "@/components/EndTreatmentNewPhoto";
import EndTreatmentHospital from "@/components/EndTreatmentHospital";
import ConfigTreatment from "@/components/ConfigTreatment";
import Instructions from "@/components/Instructions";
import FirstExample from "@/components/FirstExample";
import PhotoUpload from "@/components/PhotoUpload";
import AccesCodeError from "@/components/errors/AccessCodeError";
import MaxError from "@/components/errors/MaxError";
import ImageError from "@/components/errors/ImageError";
import IncompatibleError from "@/components/errors/IncompatibleError";
import WelcomeInfo from "@/components/WelcomeInfo";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Welcome",
      component: Welcome
    },
    {
      path: "/welcomeinfo",
      name: "WelcomeInfo",
      component: WelcomeInfo
    },
    {
      path: "/accesscode",
      name: "AccessCode",
      component: AccessCode
    },
    {
      path: "/lastdeposited",
      name: "LastDeposited",
      component: LastDeposited
    },
    {
      path: "/firstexample",
      name: "FirstExample",
      component: FirstExample
    },
    {
      path: "/photoupload",
      name: "PhotoUpload",
      component: PhotoUpload
    },
    {
      path: "/sendingphoto",
      name: "SendingPhoto",
      component: SendingPhoto,
      props: true
    },
    {
      path: "/photosent",
      name: "PhotoSent",
      component: PhotoSent
    },
    {
      path: "/errorphoto",
      name: "ErrorPhoto",
      component: ErrorPhoto,
      props: true
    },
    {
      path: "/accesscodeerror",
      name: "AccesCodeError",
      component: AccesCodeError,
      props: true
    },
    {
      path: "/maxerror",
      name: "MaxError",
      component: MaxError,
      props: true
    },
    {
      path: "/imageerror",
      name: "ImageError",
      component: ImageError,
      props: true
    },
    {
      path: "/incompatibleerror",
      name: "IncompatibleError",
      component: IncompatibleError,
      props: true
    },
    {
      path: "/properpreparation",
      name: "ProperPreparation",
      component: ProperPreparation,
      props: true
    },
    {
      path: "/configtreatment",
      name: "ConfigTreatment",
      component: ConfigTreatment
    },
    {
      path: "/deposition",
      name: "Deposition",
      component: Deposition,
      props: true
    },
    {
      path: "/instructions",
      name: "Instructions",
      component: Instructions,
      props: true
    },
    {
      path: "/endtreatmentnewphoto",
      name: "EndTreatmentNewPhoto",
      component: EndTreatmentNewPhoto
    },
    {
      path: "/endtreatmenthospital",
      name: "EndTreatmentHospital",
      component: EndTreatmentHospital
    },
    {
      path: "/processcompleted",
      name: "ProcessCompleted",
      component: ProcessCompleted
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js